export enum RouteMessages {
    MUST_SELECT_CITY = 'Debe seleccionar una georeferencia para la ciudad de forma obligatoria.',
    ERROR_SELECT_CITY = "Ha ocurrido un error asignando la georeferencia a la ciudad",
    SUCCESS_SELECT_CITY = "Se asignó la georeferencia de la ciudad de forma exitosa",
    ERROR_SELECT_ITINERARY = "Ocurrió un error al activar el itinerario",
    SUCCESS_SELECT_ITINERARY = 'Se ha guardado el itinerario de forma correcta.',
    MUST_PICK_ITINERARY = 'No hay un itinerario seleccionado, para hacerlo haga click en el títudo de la tarjeta. (Itinerario #N)',
    SUCCESS_CREATE_ROUTE = 'Se ha creado la ruta de forma correcta.'
}
